import "./Referral.css";
import { Helmet } from "react-helmet";
import { useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Topbar from "../components/Topbar/Topbar";
import Share from "./components/Share/Share";
import SidebarMobile from "../components/Sidebar/Mobile/SidebarMobile";

const Referral = () => {
 const [shareModal, setShareModal] = useState(false);
 return (
  <div className="referral-dashboard">
   <Helmet>
    <title> Referral | Dashboard | SHAP</title>
    <meta
     name="description"
     content="Knowledge-based digital products distribution at a premium"
    />
   </Helmet>
   <div className="wrapper">
    <div className="side-bar">
     <Sidebar active="referral" />
    </div>

    <div className="side-bar-mobile">
     <SidebarMobile active="referral" />
    </div>

    <div className="content-container">
     <div
      className="share-modal-wrapper"
      style={{ display: shareModal ? "block" : "none" }}
     >
      <Share setShareModal={setShareModal} />
     </div>

     <Topbar heading="Referral" />

     <div className="desktop-content">
      <div className="inner-content">
       <p style={{ color: "var(--primary-grey-text)" }}>
        Dashboard {"  >  "} Referral
       </p>
       <div className="info-container">
        <div className="item">
         <p>N0</p>
         <p>Referral balance</p>
        </div>
        <div className="item">
         <p>0</p>
         <p>Completed referrals</p>
        </div>

        <div className="item">
         <p>0</p>
         <p>Sign ups</p>
        </div>

        <div className="item">
         <p>N1000</p>
         <p>Amount per referrals</p>
        </div>
       </div>
       <div className="referral-code-container">
        <div className="first">
         <p className="title">Nsikan12</p>
         <div className="custom-input">
          <input
           type="text"
           id="copy-link"
           placeholder="copy link"
           defaultValue={"https://gamic.app/nsikan12"}
          />
          <span>Copy</span>
         </div>
        </div>
        <div className="second">
         <p className="shapBtn" onClick={() => setShareModal(true)}>
          Share Link
         </p>
        </div>
       </div>

       <div className="recent-history">
        <p>Referral History</p>
        <div className="box">No payout history available</div>
       </div>

       <div className="recent-referrals">
        <div className="item">
         <p>Referrals</p>
         <p>Referrals</p>
        </div>
        <div className="item">
         <div className="img-container">
          <div className="img-placeholder"></div>
          <div className="text-container">
           <p>You referred @ang**e9</p>
           <p>06-08-2021</p>
          </div>
         </div>
         <div className="amount">$200</div>
        </div>

        <div className="item">
         <div className="img-container">
          <div className="img-placeholder"></div>
          <div className="text-container">
           <p>You referred @ang**e9</p>
           <p>06-08-2021</p>
          </div>
         </div>
         <div className="amount">$200</div>
        </div>

        <div className="item">
         <div className="img-container">
          <div className="img-placeholder"></div>
          <div className="text-container">
           <p>You referred @ang**e9</p>
           <p>06-08-2021</p>
          </div>
         </div>
         <div className="amount">$200</div>
        </div>

        <div className="item">
         <div className="img-container">
          <div className="img-placeholder"></div>
          <div className="text-container">
           <p>You referred @ang**e9</p>
           <p>06-08-2021</p>
          </div>
         </div>
         <div className="amount">$200</div>
        </div>

        <div className="item">
         <div className="img-container">
          <div className="img-placeholder"></div>
          <div className="text-container">
           <p>You referred @ang**e9</p>
           <p>06-08-2021</p>
          </div>
         </div>
         <div className="amount">$200</div>
        </div>
       </div>
      </div>
     </div>

     <div className="mobile-content">
      <div className="referral-dashboard-mobile">
       <div className="item-container">
        <div className="item">
         <p>N0</p>
         <p>Referral balance</p>
        </div>
        <div className="item">
         <p>0</p>
         <p>Completed referrals</p>
        </div>
        <div className="item">
         <p>0</p>
         <p>Sign ups</p>
        </div>
       </div>

       <div className="link-container">
        <div>
         <p>KUFREK12</p>
         <p onClick={() => setShareModal(true)}>Share link</p>
        </div>

        <div className="custom-input">
         <input
          type="text"
          id="copy-link"
          placeholder="copy link"
          defaultValue={"https://gamic.app/nsikan12"}
         />
         <span>Copy</span>
        </div>
       </div>

       <div className="payout-history">
        <p>PAYOUT HISTORY</p>
        <div>No payout history available</div>
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Referral;
